import { post } from '@core/api/baseApi';
import { PostOrganizationThemeResponse } from '@core/types/ApiResponses';
import { NewThemePayload } from '@core/types/Theme';

const setOrganizationTheme = (payload: NewThemePayload): Promise<PostOrganizationThemeResponse> => post(`/organizations/custom-theme`, payload);

export default setOrganizationTheme;
